import { createSelector, createSlice } from '@reduxjs/toolkit';
import { twoStepComponentStates } from '../../tracking/helpers/constants.js';
export const twoStepLoginRegistrationInitialState = {
    activeState: 'accountIdentifier',
};
export const twoStepLoginRegistrationSlice = createSlice({
    name: 'basicTwoStep',
    initialState: twoStepLoginRegistrationInitialState,
    reducers: {
        updateTwoStepActiveState: (state, actions) => {
            state.activeState = actions.payload;
        },
    },
});
export const { updateTwoStepActiveState } = twoStepLoginRegistrationSlice.actions;
const twoStepLoginRegistrationState = (state) => state.forms.twoStepLoginRegistration;
export const twoStepActiveStateSelector = createSelector(twoStepLoginRegistrationState, ({ activeState }) => activeState);
export const trackingTwoStepLoginRegistrationStateSelector = createSelector(twoStepLoginRegistrationState, ({ activeState }) => twoStepComponentStates[activeState]);
export default twoStepLoginRegistrationSlice.reducer;
//# sourceMappingURL=twoStepLoginRegistrationSlice.js.map